import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6def8c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Operatör:"),
    /*#__PURE__*/_createTextVNode(" SBB (Schweiziska statens järnvägar) ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Sceniska tåg:"),
    /*#__PURE__*/_createTextVNode(" Glacier Express, Bernina Express, GoldenPass Line ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionaltrafik:"),
    /*#__PURE__*/_createTextVNode(" BLS, RhB och andra privata bolag ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.sbb.ch",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "sbb.ch")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Res smart:"),
    /*#__PURE__*/_createTextVNode(" Schweiz är dyrt – ta med matsäck och bo enklare. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Boka utsiktståg:"),
    /*#__PURE__*/_createTextVNode(" Glacier och Bernina kräver platsbiljett – boka i tid. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Interrailkort:"),
    /*#__PURE__*/_createTextVNode(" Gäller även på de flesta privata tåg (med vissa undantag). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Väder:"),
    /*#__PURE__*/_createTextVNode(" Sommaren bjuder på vandring, vintern på alpskidåkning – tågen funkar året runt. ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.sbb.ch",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "SBB – Schweiziska järnvägar")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/switzerland",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail – Schweiz")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.glacierexpress.ch",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Glacier Express")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.rhb.ch/en/home",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Rhätische Bahn (Bernina Express)")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import meta from "@/data/meta.json";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SwitzerlandGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).switzerlandGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Schweiz",
      maxHeight: "60vh",
      backgroundImageClass: "background-switzerland"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Schweiz med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Schweiz är ett paradis för tågluffare som älskar natur, precision och vyer som tar andan ur en. Här slingrar sig tågen genom alptoppar, sjödalar och idylliska byar med en punktlighet som imponerar. Det är ett av Europas mest spektakulära länder att uppleva från tågfönstret. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Schweiz" }, {
            default: _withCtx(() => [
              _createTextVNode(" Schweiz har ett mycket tätt tågnät med frekventa avgångar, även till mindre orter. Alla större städer är förbundna med snabba och bekväma IC-tåg. Interrailkort gäller över hela landet, och ofta krävs ingen platsbokning. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Schweiz",
            items: [
					{
						title: 'Klassiska Alpresan',
						description: 'Zürich → Luzern → Interlaken → Zermatt',
						link: '',
					},
					{
						title: 'Landskapsdröm',
						description: 'St. Moritz → Tirano (Bernina Express)',
						link: '',
					},
					{
						title: 'Tåg över alperna',
						description: 'Zermatt → Andermatt → St. Moritz (Glacier Express)',
						link: '',
					},
					{
						title: 'Sjöar och städer',
						description: 'Genève → Lausanne → Bern → Luzern',
						link: '',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(GridCard, {
            title: "Destinationer i Schweiz",
            items: [
					{
						title: 'Zermatt',
						image: '🏔️',
						description:
							'Fjällby vid foten av Matterhorn – perfekt för vandring och vyer.',
						link: '/guider/destinationer/schweiz/zermatt',
					},
					{
						title: 'Interlaken och Jungfrau',
						image: '🚞',
						description:
							'Porten till alperna – ta tåget till Europas högsta station.',
						link: '/guider/destinationer/schweiz/interlaken',
					},
					{
						title: 'Zürich',
						image: '🏙️',
						description:
							'Kulturell storstad med sjönära charm och utmärkta tågförbindelser.',
						link: '/guider/destinationer/schweiz/zurich',
					},
					{
						title: 'Luzern',
						image: '🌉',
						description:
							'Vackert belägen vid en sjö med närhet till berg och natur.',
						link: '/guider/destinationer/schweiz/luzern',
					},
					{
						title: 'Bern',
						image: '🕰️',
						description:
							'Medeltida gamla stan, floden Aare och charmig atmosfär.',
						link: '/guider/destinationer/schweiz/bern',
					},
					{
						title: 'St. Moritz',
						image: '🎿',
						description: 'Lyxig alpby och startpunkt för flera panoramatåg.',
						link: '/guider/destinationer/schweiz/stmoritz',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Schweiz" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})